import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Plus, ClipboardText } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export function TestEmptyState() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/20 px-6 py-16 text-center">
      <div className="mb-4 flex size-16 items-center justify-center rounded-2xl bg-primary/8">
        <ClipboardText className="size-7 text-primary" />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {t("tests.admin.emptyTitle")}
      </h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
        {t("tests.admin.empty")}
      </p>
      <Button asChild className="mt-5">
        <Link to="/dashboard/admin/tests/new">
          <Plus className="size-4" />
          {t("tests.admin.create")}
        </Link>
      </Button>
    </div>
  );
}
